import { getNodeLabelValidationErrors } from "@utils/node/labelValidation"
import { FieldErrors, FieldValues } from "react-hook-form"
import * as yup from "yup"

export const ValidationError = {
  REQUIRED: "This field is required",

  NUMBER: "Please provide numeric value",
  NUMBER_POSITIVE: "Please provide positive value",
  NUMBER_INTEGER: "Please provide integer value",

  SELECT_ONE: "Please select one of given options",

  DATE_BEFORE: (date: string) => `Please enter date before ${date}`,
  DATE_AFTER: (date: string) => `Please enter date after ${date}`,

  MAX_LENGTH: (length: number) => `Please provide no more than ${length} characters`,
  MIN_LENGTH: (length: number) => `Please provide at least ${length} characters`,
}

export const getErrorMessage = <TValues extends FieldValues = FieldValues>(
  errors: FieldErrors<TValues>,
  field: keyof TValues,
) => {
  return errors[field]?.message ?? ""
}

export const CUSTOM_ERROR_ATTRIBUTE = "data-form-error"

export const scrollToFirstFieldError = () => {
  const muiErrorSelector = ".MuiFormHelperText-root.Mui-error"
  const customErrorSelector = `[${CUSTOM_ERROR_ATTRIBUTE}="true"]`

  const errorElement = document.querySelector(`${muiErrorSelector}, ${customErrorSelector}`)
  if (!errorElement) return

  errorElement.scrollIntoView({ behavior: "smooth", block: "center" })
}

/** Validates the editable node-label format. */
export const getLabelFormatSchema = (schema?: yup.StringSchema) => {
  const baseSchema = schema || yup.string()

  return baseSchema
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .test("node-label-format", "", (value, ctx) => {
      const [error] = getNodeLabelValidationErrors(value)

      return error ? ctx.createError({ message: error }) : true
    })
}
